import DesignShell from '../components/DesignShell';
import workflowPromotion from '../content/site/workflow-promotion.md?raw';

export default function WorkflowPromotion() {
  return (
    <DesignShell
      title="Workflow Promotion"
      subtitle="Shipping a workflow across the estates — build, sync, review, deploy, publish, and promote through the environments, with approvals and common pitfalls."
      markdown={workflowPromotion}
    />
  );
}
